import { createSlice } from "@reduxjs/toolkit";
import { getTopSoldBrands } from "./topSoldBrandsAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  brands:[],
  latestRequestId: null,
};

const topSoldBrandSlice = createSlice({
  name: "topSoldBrands",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTopSoldBrands.pending, (state, action) => {
        state.loading = true;
        state.brands = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getTopSoldBrands.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.brands = action.payload;
        state.error = null;
      })
      .addCase(getTopSoldBrands.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default topSoldBrandSlice.reducer;